/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 * @flow strict-local
 */

import 'setimmediate';

if (!global.setImmediate) {
  global.setImmediate = setTimeout;
}

import React, {Component} from 'react';
import {NavigationContainer} from '@react-navigation/native';
import styled from 'styled-components/native';
import {colours} from './styles/Style';
import {
  GetUserTheme,
  GetGlobalTheme,
  IsHRWeb,
  IsHRAndroid,
  storeData,
  getAllData,
  ScreenHeight,
} from './Tools/DisplayTools';
import SideNavigator from './navigation/SideNavigator';
import TopNavigator from './navigation/TopNavigator';
import {DefaultTheme, Provider as PaperProvider} from 'react-native-paper';
import Requests, {DecodePortalString} from './api/Requests';
import {setI18nConfig} from './Tools/LanguageTools';
import * as myDate from './Tools/DateTools';
import {SetWindowDefaults} from './Tools/WindowTools';
//import Cookie from 'react-native-cookie';
import {LoginWindow} from './screens/LoginWindow';
import {ForgotPassword} from './screens/ForgotPassword';
import {Loading} from './components/status/Loading';
import {ClosedUser} from './components/status/ClosedUser';
import iconFontMCI from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import iconFontFA5 from 'react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf';
import iconFontFA5_Regular from 'react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf';
import ThemeManager from './Tools/Themes';
import {
  translate,
  SystemLanguageMatches,
  MapSystemLanguage,
  MapLanguage,
  CurrentLanguage,
} from './Tools/LanguageTools';
import DoubleTapToClose from './components/status/AndroidBackButton';
import {GetDrawers} from './navigation/SideNavigator';
import {KeychainEXC as Keychain} from './Tools/Stubs';
import {SafeAreaProvider} from 'react-native-safe-area-context';

const kStartupUnknown = 0;
const kStartupLoggedIn = 1;
const kStartupNotLoggedIn = 2;
const kStartupClosed = 3;
const kStartupForgotPassword = 4;

String.prototype.split2 = function (ch) {
  return !this ? [] : this.split(ch);
};

const iconFontStyles = `@font-face {
  src: url(${iconFontMCI});
  font-family: MaterialCommunityIcons;
}
@font-face {
  src: url(${iconFontFA5});
  font-family: FontAwesome5_Solid;
}
@font-face {
  src: url(${iconFontFA5_Regular});
  font-family: FontAwesome5_Regular;
}`;
if (IsHRWeb()) {
  const style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
  } else {
    style.appendChild(document.createTextNode(iconFontStyles));
  }
  document.head.appendChild(style);
}
const theme = {
  ...DefaultTheme,
  // Specify custom property
  myOwnProperty: true,
  // Specify custom property in nested object
  colors: {
    text: colours[GetGlobalTheme()].rowText,
    background: colours[GetGlobalTheme()].siteBackground,
  },
};

const BaseContainerView = styled.View`
  font-family: 'Montserrat';
  min-height: 100vh;
  background-color: ${colours[GetGlobalTheme()].siteBackground};
`;
/*
  min-height: 100vh;
*/
const HorizontalContainer = styled.View`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
`;

function BaseContainer(props) {
  if (IsHRWeb()) {
    return <BaseContainerView>{props.children}</BaseContainerView>;
  } else {
    return props.children;
  }
}

export function RequestEmpData(loginf = false) {
  Requests.getEmployeeData()
    .then((response) => {
      let skipf = false;
      switch (response.result.loginstatus) {
        case kStartupLoggedIn:
          if (global.setUserDetails && IsHRAndroid()) {
            Keychain.setGenericPassword(
              global.setUserDetails.username,
              global.setUserDetails.password
            );
            global.setUserDetails = null;
          }
          global.userData = response.result;
          global.PerPage = Math.floor((ScreenHeight() - 220) / 50);
          if (IsHRWeb() == false) {
            global.PerPage = Math.floor((ScreenHeight() - 220) / 47);
          }
          global.userData.apiversion = parseFloat(global.userData.apiversion);
          LoadHolidayInformation();
          LoadPasteSpecials();
          LoadWindowDefs();
          break;
        case kStartupClosed:
          global.updateLoginStatus(response.result.loginstatus);
          break;
        case kStartupForgotPassword:
          global.updateLoginStatus(response.result.loginstatus);
          break;
        default:
          if (global.testLoginCredentials == false && IsHRWeb() == false) {
            skipf = true;
            Keychain.getGenericPassword().then((credentials) => {
              if (
                credentials.username !== undefined &&
                credentials.username !== ''
              ) {
                global.testLoginCredentials = true;
                Requests.TestLogin(credentials.username, credentials.password)
                  .then((response) => {
                    global.refreshScreen(true);
                  })
                  .catch((error) => {});
              } else {
                global.updateLoginStatus(response.result.loginstatus);
              }
            });
          }
          if (global.testLoginCredentials == false) {
            if (loginf && response.result.loginstatus == kStartupNotLoggedIn) {
              alert(translate('LoginFailed'));
              if (IsHRWeb()) {
                removeCookie('HSESSION', location.hostname, '/');
              }
            }
          }
          break;
      }
      if (skipf == false && response.result.loginstatus != kStartupLoggedIn) {
        global.updateLoginStatus(response.result.loginstatus);
      }
      //global.refreshScreen();
    })
    .catch((error) => {
      global.updateLoginStatus(kStartupNotLoggedIn);
    });
}

if (IsHRWeb()) {
  global.baseURL = '';
} else {
  //global.baseURL = 'http://192.168.43.65:1291';
  //global.baseURL = 'http://192.168.0.104:1291';
  //global.baseURL = 'http://192.168.8.116:1291';
  global.baseURL = 'https://portal.excellent.lv';

  //global.baseURL = 'https://hrportal-test.excellent.lv:8082';
}
global.pasteSpecials = {};
global.duringOpen = false;
global.pasteSpecialsVector = {};
global.holidays = {};
global.resetScreen = false;
global.shiftBlock = {};
global.holidaysvector = {};
global.transferredDays = {};
global.escapeactions = [];
global.keyactions = {};
global.scrollactions = [];
global.transferredDays2 = {};
global.empInfoList = {};
global.customfields = {};
global.custompastespecials = {};
global.userData = {
  deplist: '',
  complist: [],
  selectedcomp: '',
  empname: '',
  provider: 0,
};
global.windowTile = '';
global.windowNewButton = [];
global.setUserDetails = null;
global.testLoginCredentials = false;
global.windows = {list: [], curwindow: ''};
global.windowStates = {};
global.loadingspec = 0;
global.loadedspec = 0;

export function LoadSinglePasteSpecial(table, fitlers, fields = '') {
  global.loadingspec++;
  Requests.getTableData(table, fitlers, fields)
    .then((response) => {
      switch (table) {
        case 0:
          let deplist = global.userData.deplist.split2(',');
          global.pasteSpecials[table] = [];
          global.pasteSpecialsVector[table] = {};
          response.records.map((rec, index) => {
            if (
              rec.EmpCode == global.userData.empcode ||
              deplist.indexOf(rec.DepCode) > -1
            ) {
              global.pasteSpecials[table].push(rec);
            }
            global.pasteSpecialsVector[table][rec.EmpCode] = rec;
          });
          break;
        case 1:
          let CurDate = myDate.CurrentDate();
          let deplist2 = global.userData.deplist.split2(',');
          global.pasteSpecials[table] = [];
          response.records.map((rec, index) => {
            let datef =
              rec.enddate == '' ||
              myDate.ExtractDateFromString(rec.enddate) > CurDate;
            if (
              (rec.empcode == global.userData.empcode ||
                deplist2.indexOf(rec.depcode) > -1) &&
              datef
            ) {
              global.pasteSpecials[table].push(rec);
            }
          });
          break;
        case 8:
          if (response.records.length > 0) {
            global.pasteSpecials[table] = response.records[0].rows;
          } else {
            global.pasteSpecials[table] = [];
          }
          break;
        case 11:
          global.pasteSpecials[table] = response.records;
          global.pasteSpecialsVector[table] = {};
          global.pasteSpecialsVector[table][''] = [];
          response.records.map((record, index) => {
            global.pasteSpecialsVector[table][record.postcode] = record;
          });
          break;
        case 13:
          global.pasteSpecials[table] = response.records;
          global.pasteSpecialsVector[table] = {};
          global.pasteSpecialsVector[table + '_2'] = {};
          global.pasteSpecialsVector[table][''] = '';
          response.records.map((record, index) => {
            global.pasteSpecialsVector[table][record.Code] = record.Comment;
            global.pasteSpecialsVector[table + '_2'][record.Code] = record.rows;
            /*
            global.pasteSpecialsVector[table + '_2'][record.code].push({
              shiftinterval: '!!MANUAL!!',
              intervalcomment: translate('ManualEntry'),
            });
            */
          });
          break;
        case 14:
          global.pasteSpecials[table] = response.records;
          global.pasteSpecialsVector[table] = {};
          response.records.map((record, index) => {
            global.pasteSpecialsVector[table][record.Code] = record;
          });
          break;
        case 19:
          global.pasteSpecials[table] = response.records;
          global.pasteSpecialsVector[table] = {};
          global.pasteSpecialsVector[table + '_2'] = {};
          if (global.userData.provider == 0) {
            response.records.map((record, index) => {
              global.pasteSpecialsVector[table][record.TimeStatName] = record;
              global.pasteSpecialsVector[table + '_2'][record.Code] = record;
            });
          }
          break;
        case 22:
          let res = [];
          if (response.records.length > 0) {
            for (let i in response.records) {
              res.push({
                code: response.records[i].Code,
                comment: response.records[i].Name,
                timetr: response.records[i].TimeTr,
              });
            }
          }
          global.pasteSpecials[table] = res;
          break;
        case 33: //users
          global.pasteSpecials[table] = response.records;
          global.pasteSpecialsVector[table] = {};
          response.records.map((record, index) => {
            global.pasteSpecialsVector[table][record.Code] = record;
          });
          global.pasteSpecials[table] = response.records;
          break;
        case 'VATCodeBlock': //vatcodes
          if (response.records.length > 0) {
            global.pasteSpecials[table] = response.records[0].rows;
          } else {
            global.pasteSpecials[table] = [];
          }
          break;
        default:
          global.pasteSpecials[table] = response.records;
      }
      global.loadedspec++;
      if (global.loadedspec == global.loadingspec) {
        global.updateLoginStatus(kStartupLoggedIn);
        FixPasteSpecials();
      }
    })
    .catch((error) => {});
}

function FixPasteSpecials() {
  if (global.userData.provider == 1) {
    for (let i in global.pasteSpecials[0]) {
      global.pasteSpecials[0][i].name =
        global.pasteSpecials[0][i].firstname +
        ' ' +
        global.pasteSpecials[0][i].surname;
    }
    for (let i in global.pasteSpecials[1]) {
      global.pasteSpecials[1][i].empname =
        global.pasteSpecials[1][i].firstname +
        ' ' +
        global.pasteSpecials[1][i].surname;
    }
    for (let i in global.pasteSpecials[7]) {
      global.pasteSpecials[7][i].depcode = global.pasteSpecials[7][i].code;
    }
    for (let i in global.pasteSpecials[19]) {
      global.pasteSpecials[19][i].description =
        global.pasteSpecials[19][i].name;
    }
    for (let i in global.pasteSpecials[11]) {
      global.pasteSpecials[11][i].postcode = global.pasteSpecials[11][i].code;
      global.pasteSpecials[11][i].postname = global.pasteSpecials[11][i].name;
    }
  }
  CreateFixedPasteSpecials();
  /*
  for (let i in global.pasteSpecials[11]) {
    let id = '11_' + global.pasteSpecials[11][i].depcode;
    if (global.pasteSpecials[id] === undefined) {
      global.pasteSpecials[id] = [];
    }
    global.pasteSpecials[id].push(global.pasteSpecials[11][i]);
  }
  for (let i in global.pasteSpecials) {
    if (i.includes('_')) {
      if (i.substring(-1) != '_') {
        global.pasteSpecials[i].concat(global.pasteSpecials['11_']);
      }
    }
  }
  */
}

global.PushEscapeActions = (action) => {
  global.escapeactions.splice(0, 0, action);
};
global.PopEscapeActions = () => {
  global.escapeactions.splice(0, 1);
};
global.ClearEscapeActions = () => {
  global.escapeactions.map((action, index) => {
    action();
  });
  global.escapeactions = [];
};

global.PushKeyActions = (key, action) => {
  if (global.keyactions.hasOwnProperty(key) == false) {
    global.keyactions[key] = [];
  }
  global.keyactions[key].splice(0, 0, action);
};
global.PopKeyActions = (key) => {
  global.keyactions[key].splice(0, 1);
};

global.HandleKeyDown = (e) => {
  switch (e.key) {
    case 'Escape':
      if (global.escapeactions.length > 0) {
        global.escapeactions[0](e);
      }
      break;
    default:
      if (global.keyactions.hasOwnProperty(e.key)) {
        if (global.keyactions[e.key].length > 0) {
          global.keyactions[e.key][0](e);
        }
      }
  }
};

function CreateFixedPasteSpecials() {
  global.pasteSpecials[9990] = [];
  global.pasteSpecials[9990].push({code: '0', comment: translate('Created')});
  global.pasteSpecials[9990].push({code: '1', comment: translate('Approved')});
  global.pasteSpecials[9990].push({code: '45', comment: translate('Rejected')});

  global.pasteSpecials[9991] = [];
  global.pasteSpecials[9991].push({code: 0, comment: translate('Month')});
  global.pasteSpecials[9991].push({code: 1, comment: translate('Week')});

  global.pasteSpecials[9992] = [];
  global.pasteSpecials[9992].push({code: 0, comment: translate('Employees')});
  global.pasteSpecials[9992].push({code: 1, comment: translate('Department')});
  global.pasteSpecials[9992].push({code: 2, comment: translate('Post')});

  global.pasteSpecials[9993] = [];
  let curyear = myDate.CurrentDate().getFullYear();
  for (let i = curyear - 1; i <= curyear + 3; i++) {
    global.pasteSpecials[9993].push({code: i, comment: i});
  }

  global.pasteSpecials[9994] = [];
  global.pasteSpecials[9994].push({code: '01', comment: translate('January')});
  global.pasteSpecials[9994].push({code: '02', comment: translate('February')});
  global.pasteSpecials[9994].push({code: '03', comment: translate('March')});
  global.pasteSpecials[9994].push({code: '04', comment: translate('April')});
  global.pasteSpecials[9994].push({code: '05', comment: translate('May')});
  global.pasteSpecials[9994].push({code: '06', comment: translate('June')});
  global.pasteSpecials[9994].push({code: '07', comment: translate('July')});
  global.pasteSpecials[9994].push({code: '08', comment: translate('August')});
  global.pasteSpecials[9994].push({
    code: '09',
    comment: translate('September'),
  });
  global.pasteSpecials[9994].push({code: '10', comment: translate('October')});
  global.pasteSpecials[9994].push({code: '11', comment: translate('November')});
  global.pasteSpecials[9994].push({code: '12', comment: translate('December')});
}

export function LoadEmployeeInfo(employee, callback) {
  if (global.empInfoList.hasOwnProperty(employee) == false) {
    Requests.doAction('getemployeeinfo', {id: employee})
      .then((response) => {
        global.empInfoList[employee] = response.record;
        callback();
      })
      .catch((error) => {});
  } else {
    callback();
  }
}

function LoadPasteSpecials() {
  global.updateLoginStatus(kStartupUnknown);
  global.loadingspec = 0;
  global.loadedspec = 0;
  if (global.userData.supported.indexOf('absences') > -1) {
    //LoadSinglePasteSpecial(0, {all: true}, 'EmpCode,Name,DepCode,PostCode');
    //LoadSinglePasteSpecial(1, {}, 'ContractNr,Name');
    //LoadSinglePasteSpecial(7, {});
    LoadSinglePasteSpecial(8, {});
    //LoadSinglePasteSpecial(9, {});
    //LoadSinglePasteSpecial(10, {});
    //LoadSinglePasteSpecial(11, {});
    LoadSinglePasteSpecial(19, {});
    if (global.userData.supported.indexOf('shiftsheets') > -1) {
      LoadSinglePasteSpecial(14, {});
      LoadSinglePasteSpecial(13, {});
    }
    if (global.userData.supported.indexOf('timesheets') > -1) {
      LoadSinglePasteSpecial(22, {});
    }
    //LoadSinglePasteSpecial(34, {});
    //LoadSinglePasteSpecial(28, {}, 'DefOrderType');
  }
  if (global.userData.supported.indexOf('activities') > -1) {
    //LoadSinglePasteSpecial(33, {Closed: 0}, 'Code,Name');
    //LoadSinglePasteSpecial(35, {}, 'Code,Comment');
  }

  if (global.userData.supported.indexOf('stocktakes') > -1) {
    //LoadSinglePasteSpecial(20, {});
  }
  if (global.loadingspec == 0) {
    global.updateLoginStatus(kStartupLoggedIn);
  }
}

function LoadWindowDefs(refreshf = false) {
  Requests.getWindowDefs(MapLanguage(CurrentLanguage()))
    .then((response) => {
      global.customfields = {};
      response.fields.map(function (el, index) {
        let vcname = DecodePortalString(el.window);
        global.customfields[vcname] = el.fields;
      });
      global.custompastespecials = {};
      response.pastespecials.map(function (el, index) {
        global.custompastespecials[el.pastespecial] = el;
      });
      if (refreshf) {
        global.refreshScreen();
      }
    })
    .catch((error) => {});
}

function LoadHolidayInformation() {
  Requests.getTableData(16, {})
    .then((response) => {
      Requests.getTableData(15, {CountryCode: response.records[0].CountryCode})
        .then((response2) => {
          global.holidays = response2.records[0].rows;
          response2.records[0].rows.map((day, index) => {
            global.holidaysvector[
              myDate.ConstructDateString2(
                myDate.ExtractDateFromString(day.FreeDay)
              )
            ] = true;
          });
        })
        .catch((error) => {});
      if (
        CheckCookie('set_language') != 'on' &&
        SystemLanguageMatches(
          CheckCookie('language'),
          response.records[0].LangCode
        ) == false
      ) {
        global.ToggleLanguage(MapSystemLanguage(response.records[0].LangCode));
      }
    })
    .catch((error) => {});

  Requests.getTableData(17, {})
    .then((response) => {
      global.shiftBlock = response.records[0] || {};
    })
    .catch((error) => {});

  Requests.getTableData(27, {})
    .then((response) => {
      response.records.map((rec, index) => {
        let d1 = myDate.ExtractDateFromString(rec.WorkDate);
        global.transferredDays[d1] = true;
        let d2 = myDate.ExtractDateFromString(rec.FromDate);
        global.transferredDays2[d2] = true;
      });
    })
    .catch((error) => {});
}

function DoSessionCheck() {
  Requests.testConnection()
    .then((response) => {
      setTimeout(() => {
        DoSessionCheck();
      }, 10000);
    })
    .catch((error) => {});
}

/*
for some reason tablebody.js was the first one to be called and it global.theme is undefined. 
for some reason also Platform is undefined at this state. wtf?
*/

function GetUserLanguage() {
  let res = '';
  if (IsHRWeb()) {
    let tmp = document.cookie
      .split2('; ')
      .find((row) => row.startsWith('language='));
    if (tmp) {
      res = tmp.split2('=')[1];
    }
  } else {
    if (global.language) {
      res = global.language;
    }
  }
  if (res == '') {
    res = 'en';
  }

  return res;
}

function CheckCookie(tstr) {
  let res = '';
  if (IsHRWeb()) {
    let tmp = document.cookie
      .split2('; ')
      .find((row) => row.startsWith(tstr + '='));
    if (tmp) {
      res = tmp.split2('=')[1];
    }
  }
  return res;
}

function removeCookie(sKey, sDomain, sPath) {
  Requests.ResetLogin();
}

export const LangColorContext = React.createContext({
  lang: GetUserLanguage(),
  color: GetUserTheme(),
  globalupdate: false,
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: '',
      theme: '',
      update: false,
      login: kStartupUnknown,
      showf: false,
    };
    let self = this;
    RequestEmpData();
    //DoSessionCheck();
    global.refreshScreen = (loginf = false) => {
      if (loginf) {
        RequestEmpData(true);
      } else {
        self.refreshScreen();
      }
    };
    global.updateLoginStatus = (status) => {
      self.setState({login: status});
    };
    global.ToggleColorMode = () => {
      self.ToggleColorMode();
    };
    global.ToggleLanguage = (langcode) => {
      if (langcode != '') {
        self.ToggleLanguage(langcode);
      }
    };
    getAllData().then((res) => {
      global.theme = res[1][1];
      global.language = res[0][1];
      let tlanguage = GetUserLanguage();
      let colourTheme = GetUserTheme();
      self.state.language = tlanguage;
      global.language = tlanguage;
      if (IsHRWeb()) {
        if (CheckCookie('windowstates') != '') {
          global.windowStates = JSON.parse(CheckCookie('windowstates'));
        }
      } else {
        if (res[2] && res[2][1] != null && res[2][1] != '') {
          global.windowStates = JSON.parse(res[2][1]);
        }
      }
      SetWindowDefaults();
      self.state.theme = colourTheme;
      global.theme = colourTheme;
      setI18nConfig(tlanguage);
      if (IsHRWeb()) {
        document.title = translate('ExcellentPortal');
      }
      self.setState({showf: true});
    });

    if (IsHRWeb()) {
      document.addEventListener(
        'keydown',
        (e) => global.HandleKeyDown(e),
        false
      );
      //document.addEventListener("scroll", (e) => global.HandleScroll(e), false);
    }
  }

  ToggleColorMode = () => {
    global.theme = global.theme === 'light' ? 'dark' : 'light';
    if (IsHRWeb()) {
      document.cookie = 'colortheme=' + global.theme;
    } else {
      storeData('@colortheme', global.theme);
    }
    //this.setState({theme: data});
    this.refreshScreen();
  };

  ToggleLanguage = (data) => {
    this.setState({language: data});
    setI18nConfig(data);
    if (IsHRWeb()) {
      let now = new Date();
      now.setFullYear(now.getFullYear() + 2);
      document.cookie =
        'language=' + data + ';expires=' + now.toUTCString() + ';path=/';
      document.cookie =
        'set_language=on;expires=' + now.toUTCString() + ';path=/';
    } else {
      storeData('@language', data);
      storeData('@set_language', 'on');
    }
    global.language = data;
    CreateFixedPasteSpecials();
    LoadWindowDefs(true);
  };
  refreshScreen = () => {
    this.setState({update: this.state.update ? false : true});
  };

  ShowBaseContainer = () => {
    let linking = {
      config: {screens: {}},
    };
    GetDrawers(1).map((link, index) => {
      if (link.recordlink) {
        let obj = {};
        obj.screens = {};
        obj.screens[link.list] = link.link;
        obj.screens[link.record] = link.recordlink;
        if (link.extra) {
          obj.screens[link.extra] = link.extralink;
        }
        linking.config.screens[link.screen] = obj;
      } else {
        linking.config.screens[link.screen] = link.link;
      }
    });
    setTimeout(function () {
      if (GetDrawers().length == 0) {
        if (global.userData.complist.length == 0) {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('NoAccessToAnyComp'),
          });
        } else {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('NoAccessToComp'),
          });
        }
      }
    }, 500);
    return (
      <BaseContainer>
        <NavigationContainer linking={linking}>
          <TopNavigator />
          <HorizontalContainer>
            {GetDrawers().length > 0 && <SideNavigator />}
          </HorizontalContainer>
        </NavigationContainer>
      </BaseContainer>
    );
  };

  render() {
    if (this.state.showf == false) {
      return <PaperProvider></PaperProvider>;
    } else {
      return (
        <ThemeManager>
          <LangColorContext.Provider
            value={{
              language: this.state.language,
              theme: this.state.theme,
              globalupdate: global.isDrawerOpen ? global.isDrawerOpen() : false,
            }}
          >
            <PaperProvider
              theme={theme}
              style={{
                backgroundColor: colours[GetGlobalTheme()].siteBackground,
              }}
              key={this.state.language + global.theme}
            >
              <SafeAreaProvider>
                {this.state.login == kStartupLoggedIn && (
                  <>{this.ShowBaseContainer()}</>
                )}
                {this.state.login == kStartupClosed && <ClosedUser />}
                {this.state.login == kStartupNotLoggedIn && (
                  <LoginWindow navigation={this.props.navigation} />
                )}
                {this.state.login == kStartupForgotPassword && (
                  <ForgotPassword />
                )}
                {this.state.login == kStartupUnknown && <Loading />}
                <DoubleTapToClose />
              </SafeAreaProvider>
            </PaperProvider>
          </LangColorContext.Provider>
        </ThemeManager>
      );
    }
  }
}

// export default createBrowserApp(App);
export default App;
